<template>
  <div class="main-container-l">
    <div class="loading-container" v-if="loading"><img src="../../assets/img/loading.svg"></div>
    <div class="offer-container-l">
      <div class="group-offer-l">
        <SportSingleResults :matchesIn="matchesIn" v-on:matchchange="matchChange"/>
      </div>
    </div>
  </div>
</template>

<script>

import {
    mapActions,
    mapGetters,
} from 'vuex';

import SportSingleResults from './containers/SportSingleResults.vue';

export default {
    name: 'MatchMobileResults',
    components:
    {
        SportSingleResults,
    },
    data()
    {
        return {
            matchesIn: {},
            loading: false,
        };
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'isMobile',
            'sportState',
            'sportTree',
            'offerStructLoaded',
            'offerHandling',
        ]),
    },
    watch:
    {
        isMobile(val)
        {
            const me = this;
            if (!val)
            {
                me.$router.go(-1);
            }
        },
    },
    methods: {
        ...mapActions([]),
        matchChange(match)
        {
            const me = this;
            const tempObj = {};

            tempObj[match.matchId] = match;
            me.matchesIn = { ...me.matchesIn, ...tempObj };
        },
        updateMatch(match)
        {
            const me = this;

            if (match.matchId !== me.$route.params.matchId)
            {
                return;
            }

            match.utc = match.md;

            me.$set(me.matchesIn, match.matchId, match);
        },
    },
};
</script>

<style>

</style>
